import '@keepeek/commons';

var ComponentOverrideKey;
(function (ComponentOverrideKey) {
    ComponentOverrideKey["ActiveFilters"] = "ActiveFilters";
    ComponentOverrideKey["ElementCount"] = "ElementCount";
    ComponentOverrideKey["ElementSummary"] = "ElementSummary";
    ComponentOverrideKey["KGrid"] = "KGrid";
    ComponentOverrideKey["Dataview"] = "Dataview";
    ComponentOverrideKey["MediaDetail"] = "MediaDetail";
    ComponentOverrideKey["Custom"] = "Custom";
    // Filters
    ComponentOverrideKey["FilterCheckbox"] = "FilterCheckbox";
    ComponentOverrideKey["FilterRadio"] = "FilterRadio";
    ComponentOverrideKey["FilterDate"] = "FilterDate";
    ComponentOverrideKey["FilterText"] = "FilterText";
    ComponentOverrideKey["FilterDuration"] = "FilterDuration";
    ComponentOverrideKey["KTemplates"] = "KTemplates";
    ComponentOverrideKey["KHead"] = "KHead";
    ComponentOverrideKey["KScripts"] = "KScripts";
    ComponentOverrideKey["DetailDownloadButton"] = "DetailDownloadButton";
})(ComponentOverrideKey || (ComponentOverrideKey = {}));
var LayoutOverrideKey;
(function (LayoutOverrideKey) {
    LayoutOverrideKey["LandingPageLayout"] = "LandingPageLayout";
    LayoutOverrideKey["DefaultLayout"] = "DefaultLayout";
    LayoutOverrideKey["ShareLayout"] = "ShareLayout";
    LayoutOverrideKey["BasketLayout"] = "BasketLayout";
})(LayoutOverrideKey || (LayoutOverrideKey = {}));

export { ComponentOverrideKey, LayoutOverrideKey };
//# sourceMappingURL=customer-override.js.map
